import React, { useContext, useEffect, useState } from 'react';
import HomeTwoSingleBlog from '../../../components/HomeTwoSingleBlog/HomeTwoSingleBlog';
import { CgArrowLongRight } from 'react-icons/cg';
import { fetchBlogFeed } from '../../../lib/blogFeed';
import { AppContext } from '../../../context/AllContext';
import LoaderSpiner from '../../../components/LoadersSpiner/loader';
import { useTranslation } from "react-i18next";
import { trackEvent } from "../../../lib/analytics";





const HomeTwoBlogs = () => {
   const { t } = useTranslation();
   const { language } = useContext(AppContext);

   const [articles, setArticle] = useState([]);
   // Sin esto, si el feed falla o viene vacío el spinner giraba para siempre.
   const [loaded, setLoaded] = useState(false);

   // Feed del Headless CMS, el mismo que sirve /blog en Next.js. Antes pedía
   // `public/blog/mixed`, una ruta comentada en el core que responde 404.
   useEffect(() => {
     let alive = true;
     setLoaded(false);
     fetchBlogFeed({ lang: language, pageSize: 3 })
       .then((items) => { if (alive) setArticle(items); })
       .catch(() => { if (alive) setArticle([]); })
       .finally(() => { if (alive) setLoaded(true); });
     return () => { alive = false; };
   }, [language]);

   const filteredArticles = articles.slice(0, 3);


   const dataArray = filteredArticles.map((article) => {
      return (
         <HomeTwoSingleBlog key={article.UUID || article.link} date={(article.created_at || '').split("T")[0]} name={article.author} desc={article.title} link={article.link} article={article}/>

      //   <BlogSingleItem
      //      key={article.UUID}
      //     image="2"
      //     user_image="1"
      //     name={article.author}
      //     title={article.title}
      //     article={article}
      //     date={article.created_at.split("T")[0]}
      //   />

      );
    });



   return (
      <>
         <section className="blog__area grey-bg-15 pt-115 pb-135">
            <div className="container">
               <div className="row">
                  <div className="col-xl-5">
                     <div className="section__title section__title-3 mb-65">
                        <span>{t("home_two_blogs_title_mini")}</span>
                        <h2>{t("home_two_blogs_title_big")}</h2>
                     </div>
                  </div>
               </div>
               <div className="row">



               {!loaded ? (
                  <LoaderSpiner />
               ) : articles.length > 0 ? (
                  // <div>{dataArray}</div>
                  <div style={{
                     display: "flex",
                     gap: "20px",
                     // overflowX: "auto",
                     padding: "10px"
                  }} >{dataArray}</div>

                  // <ContainerArticles data={currentPosts} />
                ) : null}


                  {/* <HomeTwoSingleBlog date="24" name="Elon Gated" desc="The Start-Up Ultimate Guide to Make Your WordPress Journal." />
                  <HomeTwoSingleBlog date="12" name="Lance Bogrol" desc="Businesses Are Thriving, Societies Are Not. Time for Urgent Change" />
                  <HomeTwoSingleBlog date="10" name="Shahnewaz Sakil" desc="For Banks, Modernizing Technology Has Become a Perpetual Challenge" /> */}

               </div>
               <div className="row">
                  <div className="col-xl-12">
                     <div className="blog__more mt-60">
                         <a
                           href="/blog"
                           className="z-btn z-btn-border"
                           onClick={() =>
                              trackEvent("Engagement", "Open Blog", "Home Blogs CTA")
                           }
                        >
                           {t("home_two_blogs_button")}
                           <i > <CgArrowLongRight /> </i>
                        </a>
                     </div>
                  </div>
               </div>
            </div>
         </section>
      </>
   );
};




 export default HomeTwoBlogs;


 
 
